import {retryPromise} from '@utils/retryPromise';
import dynamic from 'next/dynamic';

export const MobileMenu = dynamic(
  retryPromise(() =>
    import(/* webpackChunkName: "mobileMenu" */ './MobileMenu').then(
      ({MobileMenu}) => MobileMenu,
    ),
  ),
  {ssr: false},
);
